/**
 * `<lottie-player>` is a custom element, and at ~334 KB minified it was a third
 * of the whole bundle — paid for by every page of the site, while only 10
 * templates (31 of the 148 entries that set one) contain the element and no
 * page-builder set does.
 *
 * It is a separate chunk now, fetched only when the page actually has one. The
 * elements already in the DOM upgrade themselves as soon as the definition
 * arrives, so nothing else has to wait for it.
 */
export function initLottiePlayer() {
    if (!document.querySelector('lottie-player')) {
        return null;
    }

    return import('@lottiefiles/lottie-player');
}
